import React from 'react';
import { Typography } from '@mui/material';

const MyAccountChangePasswordPage: React.FC = () => {
  return (
    <div>
      <Typography variant="h3">My Account Change Password Page</Typography>
      <Typography>This is a demo About page using Material UI.</Typography>
    </div>
  );
};

export default MyAccountChangePasswordPage;
